import { LSIDUserIdentity } from "@shopkeep/lsid-types";
import { fetchJSON } from "lib/fetch";
import { getStore } from "store";
import config from "site-config";
import { setLsidIdentity } from "../actions/lsid-actions";

export interface ILsidJwtResponse {
    lsid_oidc_auth_token: string;
    lsid_identity: LSIDUserIdentity;
}
export interface IState {
    params: any;
    [prop: string]: any;
}
type TReplace = (params: any) => void;
type ICallback = () => void;

/**
 *  request against the LS identity-service to get raw jwt token for user
 *
 */
export default function (nextState: IState, replace: TReplace, callback: ICallback) {
    const store = getStore();
    const url = `${config.api}/auth/oidc/identity`;
    fetchJSON<ILsidJwtResponse>(url, { method: "GET" })
        .then((response) => {
            store.dispatch(setLsidIdentity(formatPayload(response.lsid_identity, response.lsid_oidc_auth_token)));
        })
        .catch((_error) => {
            callback();
        });
    callback();
}

const formatPayload = function (identity: LSIDUserIdentity, lsidToken: string): any {
    return {
        userGrants: identity?.grants?.user || {},
        accountGrants: identity?.grants?.account || {},
        features: identity?.features || [],
        accountFeatures: identity?.accountFeatures || {},
        lsidToken: lsidToken,
    };
};
